export { default } from './PaginationCore';
